import { Converter } from '../types/converter';

export const energyConverter: Converter = {
  id: 'energy',
  name: 'Energy Converter',
  icon: 'Zap',
  categories: ['common', 'engineering', 'physics'],
  units: [
    // SI units and derivatives
    { name: 'Joule', symbol: 'J', factor: 1 },
    { name: 'Kilojoule', symbol: 'kJ', factor: 1000 },
    { name: 'Megajoule', symbol: 'MJ', factor: 1e6 },
    { name: 'Gigajoule', symbol: 'GJ', factor: 1e9 },
    { name: 'Millijoule', symbol: 'mJ', factor: 0.001 },
    { name: 'Microjoule', symbol: 'µJ', factor: 1e-6 },
    { name: 'Nanojoule', symbol: 'nJ', factor: 1e-9 },
    { name: 'Attojoule', symbol: 'aJ', factor: 1e-18 },

    // Electrical energy units
    { name: 'Kilowatt-hour', symbol: 'kW·h', factor: 3.6e6 },
    { name: 'Watt-hour', symbol: 'W·h', factor: 3600 },
    { name: 'Gigawatt-hour', symbol: 'GW·h', factor: 3.6e12 },
    { name: 'Megawatt-hour', symbol: 'MW·h', factor: 3.6e9 },
    { name: 'Kilowatt-second', symbol: 'kW·s', factor: 1000 },
    { name: 'Watt-second', symbol: 'W·s', factor: 1 },

    // Caloric units
    { name: 'Calorie (nutritional)', symbol: 'Cal', factor: 4186.8 },
    { name: 'Kilocalorie (International Table)', symbol: 'kcal (IT)', factor: 4186.8 },
    { name: 'Kilocalorie (Thermochemical)', symbol: 'kcal (th)', factor: 4184 },
    { name: 'Calorie (International Table)', symbol: 'cal (IT)', factor: 4.1868 },
    { name: 'Calorie (Thermochemical)', symbol: 'cal (th)', factor: 4.184 },

    // BTU units
    { name: 'BTU (International Table)', symbol: 'Btu (IT)', factor: 1055.05585262 },
    { name: 'BTU (Thermochemical)', symbol: 'Btu (th)', factor: 1054.35026444 },
    { name: 'Mega BTU (International Table)', symbol: 'MBtu (IT)', factor: 1.05505585262e9 },

    // Power-time units
    { name: 'Horsepower hour', symbol: 'hp·h', factor: 2.684519537696172e6 },
    { name: 'Horsepower (metric) hour', symbol: 'hp·h (metric)', factor: 2.647795507e6 },

    // Atomic and particle physics
    { name: 'Electron-volt', symbol: 'eV', factor: 1.602176634e-19 },
    { name: 'Kiloelectron-volt', symbol: 'keV', factor: 1.602176634e-16 },
    { name: 'Megaelectron-volt', symbol: 'MeV', factor: 1.602176634e-13 },
    { name: 'Hartree energy', symbol: 'Eh', factor: 4.359744650e-18 },
    { name: 'Rydberg constant', symbol: 'Ry', factor: 2.179872325e-18 },

    // CGS and other scientific units
    { name: 'Erg', symbol: 'erg', factor: 1e-7 },
    { name: 'Dyne centimeter', symbol: 'dyn·cm', factor: 1e-7 },

    // Force-distance units
    { name: 'Newton meter', symbol: 'N·m', factor: 1 },
    { name: 'Gram-force meter', symbol: 'gf·m', factor: 0.00980665 },
    { name: 'Gram-force centimeter', symbol: 'gf·cm', factor: 0.0000980665 },
    { name: 'Kilogram-force meter', symbol: 'kgf·m', factor: 9.80665 },
    { name: 'Kilogram-force centimeter', symbol: 'kgf·cm', factor: 0.0980665 },
    { name: 'Kilopond meter', symbol: 'kp·m', factor: 9.80665 },
    { name: 'Pound-force foot', symbol: 'lbf·ft', factor: 1.355817948 },
    { name: 'Pound-force inch', symbol: 'lbf·in', factor: 0.112984829 },
    { name: 'Ounce-force inch', symbol: 'ozf·in', factor: 0.007061551812 },
    { name: 'Foot-pound', symbol: 'ft·lbf', factor: 1.355817948 },
    { name: 'Inch-pound', symbol: 'in·lbf', factor: 0.112984829 },
    { name: 'Inch-ounce', symbol: 'in·ozf', factor: 0.007061551812 },
    { name: 'Poundal foot', symbol: 'pdl·ft', factor: 0.042140110093 },

    // Thermal energy units
    { name: 'Therm', symbol: 'thm', factor: 1.05505585262e8 },
    { name: 'Therm (EC)', symbol: 'thm (EC)', factor: 1.05506e8 },
    { name: 'Therm (US)', symbol: 'thm (US)', factor: 1.054804e8 },
    { name: 'Ton-hour (refrigeration)', symbol: 'ton·h', factor: 1.2660670177e7 },

    // Fuel equivalents
    { name: 'Fuel oil equivalent @kiloliter', symbol: 'FOE (kL)', factor: 4.0176e10 },
    { name: 'Fuel oil equivalent @barrel (US)', symbol: 'FOE (bbl)', factor: 6.383e9 },

    // Explosive energy
    { name: 'Gigaton', symbol: 'Gton', factor: 4.184e18 },
    { name: 'Megaton', symbol: 'Mton', factor: 4.184e15 },
    { name: 'Kiloton', symbol: 'kton', factor: 4.184e12 },
    { name: 'Ton (explosives)', symbol: 'ton (TNT)', factor: 4.184e9 }
  ]
};
